import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'
import { AppStore } from './models/modelsStore'
import { inject } from '@angular/core'
import { LocalStorageService } from './services/local-storage.service'
import { User } from '@session/models/session'

export const INITIAL_STATE: AppStore = {
  preferences: {
    language: '',
    theme: '',
  },
  session: {
    accessToken: '',
    deviceToken: '',
    user: {
      accountId: '',
      agreementAccepted: false,
      email: '',
      firstName: '',
      lastName: '',
      phoneNumer: '',
      isUsedInvitationCode: false,
    },
  },
}

export const StoreSession = signalStore(
  { providedIn: 'root' },
  withState((localStorageService = inject(LocalStorageService)) => localStorageService.getStore()),
  withMethods(store => {
    return {
      //Session methods
      changeEmail: (email: string) => {
        patchState(store, state => ({
          session: {
            ...state.session,
            user: {
              ...state.session.user,
              email,
            },
          },
        }))
      },
      changeAccesToken: (accessToken: string) => {
        patchState(store, state => ({
          session: {
            ...state.session,
            accessToken,
          },
        }))
      },
      changeDeviceToken: (deviceToken: string) => {
        patchState(store, state => ({
          session: {
            ...state.session,
            deviceToken,
          },
        }))
      },
      updateUser: (user: User) => {
        patchState(store, state => ({
          session: {
            ...state.session,
            user,
          },
        }))
      },
      logOut: () => {
        patchState(store, state => ({
          session: {
            ...INITIAL_STATE.session,
            user: {
              ...INITIAL_STATE.session.user,
              email: state.session.user.email,
            },
          },
        }))
      },
    }
  }),
)
